import React, { useEffect } from 'react';
import { Form, Input, Select, Button, Space, Typography } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import './css/EditRealmForm.css'; // Assuming you have a CSS file for styles
import ExportRealmButton from './ExportRealmButton'; // Importing ExportRealmButton

const { Option } = Select;

const EditRealmForm = ({ realm, onSubmit, onCancel, realmTypes }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (realm) {
      form.setFieldsValue({
        realmId: realm.PK_RealmId,
        type: realm.SK_Type,
        description: realm.payload?.description || '',
        notes: realm.payload?.notes || [],
      });
    }
  }, [realm, form]);

  return (
    <div className="login-form">

      <Form
        layout="vertical"
        form={form}
        onFinish={onSubmit}
        className="fill-width"
      >
        <Form.Item
          label="Realm ID"
          name="realmId"
          rules={[{ required: false }]}
          className="custom-form-item"
        >
          <Input disabled className="realm-form-item-readonly" />
        </Form.Item>

        <Form.Item
          label="Type"
          name="type"
          rules={[{ required: true }]}
          className="custom-form-item"
        >
          <Select placeholder="Select a realm type" className="realm-form-item-select">
            {realmTypes.map((type) => (
              <Option key={type} value={type}>
                {type}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Description" name="description" className="custom-form-item">
          <Input.TextArea rows={3} className="fab-input" />
        </Form.Item>

        <Form.List name="notes">
          {(fields, { add, remove }) => (
            <>
              <label className="text-orange">Notes</label>
              {fields.map(({ key, name, ...restField }) => (
                <Space
                  key={key}
                  style={{ display: 'flex', marginBottom: 8 }}
                  align="baseline"
                >
                  <Form.Item
                    {...restField}
                    name={name}
                    rules={[{ required: true, message: 'Note is required' }]}
                  >
                    <Input placeholder="Note" className="fab-input" />
                  </Form.Item>
                  <MinusCircleOutlined
                    onClick={() => remove(name)}
                    className="primary-icon"
                  />
                </Space>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined />}
                  className="primary realm-form-add-note-button"
                >
                  Add Note
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>

        
        <div className="realm-form-footer">
          {/* left‑side pair */}
          <div className="left-buttons">
            <Button htmlType="submit" className="primary">
              Update
            </Button>
            <Button onClick={onCancel} className="secondary-btn realm-form-cancel-button">
              Cancel
            </Button>
          </div>

          {/* far‑right export */}
          <ExportRealmButton />
        </div>

      </Form>
      
    </div>
  );
};

export default EditRealmForm;
